/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropType from 'prop-types';

import { Button, CircularProgress } from '@mui/material';

function NButton(props) {
  const { className, variant, isLoading } = props;
  return (
    <div className={`App-inputs input-button ${isLoading && 'loading'} ${variant}`}>
      <Button
        disabled={isLoading}
        endIcon={
          isLoading && (
            <div className='btn-loading-loader'>
              <CircularProgress />
            </div>
          )
        }
        className={className || ''}
        variant={variant}
        {...props}
      >
        {props?.children}
      </Button>
    </div>
  );
}

NButton.propTypes = {
  variant: PropType.oneOfType(['Ncontained', 'Noutline']),
  className: PropType.string,
  children: PropType.any,
  isLoading: PropType.bool,
};

NButton.defaultProps = {
  variant: 'Ncontained',
  className: '',
  children: undefined,
  isLoading: false,
};

export default NButton;
